/**
 * Created by ivan on 22.02.18.
 */

const CakeCellView = BaseCellView.extend({
    ctor: function (cakeCell) {
        this._super();

        if (cakeCell.isForGoal) {
            this.initGoal(cakeCell);
            return;
        }

        const bigComponent = cakeCell.findComponent(BigComponent);
        if (bigComponent.isHead) {
            this.initHead(cakeCell);
        }
        this.initialize(cakeCell);
    },

    initGoal: function (cakeCell) {
        const styles = cleverapps.styles.CakeCellView;
        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize(styles.goal.width, styles.goal.height);
        const bundle = cakeCell.bundleId();
        const goalImage = new cc.Sprite(bundles[bundle].frames[`${bundle}_goal_png`]);
        goalImage.setAlignment(this.width / 2, this.height / 2);

        this.addChild(goalImage);
        this.cell = cakeCell;

        if (!cakeCell.isDartsSkin()) {
            goalImage.setScaleX(-1);
        }
    },

    initHead: function (cakeCell) {
        const styles = cleverapps.styles.CakeCellView;
        this.setContentSize2(styles.width, styles.height);
        this.setAnchorPoint(0.5, 0.5);

        const bundle = cakeCell.bundleId();
        const plate = this.plate = new cc.Sprite(bundles[bundle].frames[`${bundle}_plate_png`]);
        plate.setAnchorPoint(0.5, 0.5);
        plate.setAlignment(this.width / 2, this.height / 2);
        this.addChild(plate);

        if (!cakeCell.isDartsSkin()) {
            const anchors = {
                1: { "x": 1, "y": 0 },
                2: { "x": 0, "y": 0 },
                3: { "x": 1, "y": 1 },
                4: { "x": 0, "y": 1 }
            };
            const position = {
                1: { "x": this.width / 4, "y": this.height * 3 / 4 },
                2: { "x": this.width * 3 / 4, "y": this.height * 3 / 4 },
                3: { "x": this.width / 4, "y": this.height / 4 },
                4: { "x": this.width * 3 / 4, "y": this.height / 4 }
            };
            this.images = {};
            for (let part = 1; part <= 4; ++part) {
                const image = new cc.Sprite(bundles[bundle].frames[`${bundle}_${part}_3_png`]);
                image.setAnchorPoint(anchors[part]);
                this.addChild(image);
                const x = position[part].x + (anchors[part].x - 0.5) * image.width;
                const y = position[part].y + (anchors[part].y - 0.5) * image.height;
                image.setAlignment(x, y);
                this.images[part] = image;
            }
        }

        const bigComponent = cakeCell.findComponent(BigComponent);
        for (let dx = 0; dx < Field.SIZE; dx++) {
            for (let dy = 0; dy < Field.SIZE; dy++) {
                const cell = Game.currentGame.field.cells[dy][dx];
                if (cell === undefined) {
                    continue;
                }
                if (cell instanceof CakeCell && cell.findComponent(BigComponent).head === bigComponent.head) {
                    if (cakeCell.isDartsSkin()) {
                        for (let i = 0; i < 3 - cell.lives; i++) {
                            this.dartsChangeLives(cell, {
                                silent: true,
                                lives: 2 - i
                            });
                        }
                    } else if (cell.lives > 0) {
                        this.images[cell.part].setSpriteFrame(this.getImage(cell));
                    } else {
                        this.images[cell.part].visible = false;
                    }
                }
            }
        }
    },

    getStyles: function () {
        return cleverapps.styles.CakeCellView;
    },

    initialize: function (cakeCell) {
        this._super(cakeCell);

        cakeCell.onChangeLivesListener = this.createListener(this.changeLives.bind(this));
        this.setAlignment(BaseCellView.alignInTheGrid(cakeCell.x + 0.5, cakeCell.y + 0.5));
    },

    unuse: function () {
        this.cell.onChangeLivesListener = function () {};

        this._super();
    },

    getImage: function (cell) {
        cell = cell || this.cell;
        const bundle = cell.bundleId();
        return bundles[bundle].frames[`${bundle}_${cell.part}_${cell.lives}_png`];
    },

    changeLives: function (cell) {
        const bigComponent = this.cell.findComponent(BigComponent);
        if (!bigComponent.isHead) {
            return;
        }

        if (cell.isDartsSkin()) {
            this.dartsChangeLives(cell);
            return;
        }

        if (cell.lives > 0) {
            this.images[cell.part].setSpriteFrame(this.getImage(cell));
        } else {
            this.images[cell.part].visible = false;
        }

        const animation = CakeAnimation.factory(this.cell.bundleId());
        animation.setPosition(BaseCellView.alignInTheGrid(cell.x, cell.y));
        if (!animation.parent) {
            this.parent.addChild(animation);
        }
        animation.runAnimate("animation");

        const bundle = cell.bundleId();
        const goalImage = new cc.Sprite(bundles[bundle].frames[`${bundle}_fly_png`] || bundles[bundle].frames[`${bundle}_goal_png`]);
        goalImage.setPosition(BaseCellView.alignInTheGrid(cell.x, cell.y));
        this.parent.addChild(goalImage);
        goalImage.setScale(0.5);

        const goal = Game.currentGame.goals.findTargetFor(cell.getGoalId());
        goal.collect(1, goalImage);
    },

    dartsChangeLives: function (cell, options) {
        options = options || {};
        const lives = (options.lives !== undefined) ? options.lives : cell.lives;
        const styles = cleverapps.styles.CakeCellView;

        const partRot = {
            1: -90,
            2: 0,
            3: 180,
            4: 90
        };
        if (lives >= 0) {
            const baseRot = -90;
            const pos = styles.positions[cell.part][2 - lives];
            const targetPos = cc.p(this.plate.x + pos.x, this.plate.y + pos.y);
            const dist = Math.sqrt(pos.x * pos.x + pos.y * pos.y);
            const k = styles.startDistance / dist;
            const startPos = cc.p(this.plate.x + pos.x * k, this.plate.y + pos.y * k);
            const bundle = cell.bundleId();
            const dart = new cc.Sprite(dist <= styles.centerRadius ? bundles[bundle].frames[`${bundle}_dart_middle_png`] : bundles[bundle].frames[`${bundle}_dart_png`]);
            this.addChild(dart);
            dart.setAlignment(options.silent ? targetPos : startPos);
            dart.setRotation(baseRot + partRot[cell.part] + (2 - lives) * 30 + 15);

            if (!options.silent) {
                dart.setScale(1.5);
                this.setLocalZOrder(11);
                dart.runAction(
                    new cc.Sequence(
                        new cc.Spawn(
                            new cc.FadeIn(0.2),
                            new cc.MoveTo(0.2, targetPos).easing(cc.easeIn(5)),
                            new cc.ScaleTo(0.2, 1.0)
                        ),
                        new cc.CallFunc(() => {
                            this.setLocalZOrder(this.baseZOrder);
                        })
                    )
                );
            }
        }
    },

    startExploding: function () {
        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.3),
            new cc.ScaleTo(0.3, 0),
            new cc.RemoveSelf()
        ));
    },

    hurtAnimation: function () {
        const bigComponent = this.cell.findComponent(BigComponent);
        if (!bigComponent.isHead) {
            return;
        }

        const DURATION = 0.2;
        this.runAction(new cc.Sequence(
            new cc.ScaleTo(DURATION, 0.9),
            new cc.ScaleTo(DURATION, 1)
        ));
    }
});

cleverapps.styles.CakeCellView = {
    width: 240,
    height: 240,

    goal: {
        width: 120,
        height: 120
    },

    hover: {
        y: 10
    }
};